// 임플란트 갯수 4개
// 랜딩 16번
// 데이터 들어가는지 잘 확인해야하는 랜딩
// 폼으로 변경해야하는데 스타일 꼭 확인하기// 폼으로 변경해야하는데 스타일 꼭 확인하기// 폼으로 변경해야하는데 스타일 꼭 확인하기
// 폼으로 변경해야하는데 스타일 꼭 확인하기// 폼으로 변경해야하는데 스타일 꼭 확인하기// 폼으로 변경해야하는데 스타일 꼭 확인하기
import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import PrivacyContent from "./PrivacyContent";
import RandingConsent from "./RandingConsent";

function RandingStyle7({
  urlCode,
  urlCodeSettingId,
  img1Path,
  img2Path,
  img3Path,
  img4Path,
  img5Path,
  bottomIMG,
  formFieldColor,
  qOptions,
  numberColor,
  keepBTN,
  postBTN,
  qOptionImgPath,
  companyName,
  privacyCompanyName,
  colorRequest,
  footerPath,
  addStyle,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();
  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isMarketingAgreed, setIsMarketingAgreed] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
    console.log(option);
  };

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <div className="form-container">
      <div className="step2">
        {img1Path && <img src={img1Path} alt="임플란트 고민중이세요?" />}
        {img2Path && <img src={img2Path} alt="임플란트 고민중이세요?" />}
        {img3Path && <img src={img3Path} alt="임플란트 고민중이세요?" />}

        <div className="qBox">
          {img4Path && <img src={img4Path} alt="임플란트 고민중이세요?" />}
          <div className="qOptions twobytwo">
            {(qOptions || options).map((option, index) => (
              <img
                key={index}
                src={`${qOptionImgPath}/qoption${index + 1}${
                  selectedOption === option ? "(1)" : ""
                }.png`}
                alt={option}
                onClick={() => handleSelectImplant(option)}
              />
            ))}
          </div>
          {bottomIMG && <img src={bottomIMG} alt="임플란트 고민중이세요?" />}
          <form
            className="ColorRequest"
            style={{ backgroundColor: colorRequest, ...addStyle }}
            onSubmit={(e) => {
              e.preventDefault(); // 기본 제출 동작 방지
              handleSubmit(); // 기존 handleSubmit 호출
            }}
          >
            <div className="formBox randingMargintop">
              {img5Path && <img src={img5Path} alt="임플란트 고민중이세요?" />}
              <div
                className={`formField ${
                  formFieldColor === "white" ? "white" : ""
                }`}
              >
                <label htmlFor="name">이름</label>
                <input
                  type="text"
                  id="name"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <PhoneNumberInput
                phoneNumber={phoneNumber}
                phoneFirstOptions={phoneFirstOptions}
                handlePhoneNumberChange={handlePhoneNumberChange}
                formFieldColor={formFieldColor}
              />
            </div>
            <p className="benefitInfo">
              <BenefitPeriod />
              <br />
              이벤트 대상자 : 해당 매체 이용자
            </p>
            <RandingConsent
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              isMarketingAgreed={isMarketingAgreed}
              setIsMarketingAgreed={setIsMarketingAgreed}
              companyName={privacyCompanyName || companyName || "수집주체명"}
              privacyContent={
                <PrivacyContent companyName={privacyCompanyName || companyName || "수집주체명"} />
              }
            />
            <button
              type="submit"
              className="sendBtnBox"
              disabled={isSubmitting}
            >
              <img src={postBTN} alt="신청하기" />
            </button>
          </form>
        </div>
      </div>

      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </div>
  );
}

export default RandingStyle7;
